import React, { useState, useEffect  , useRef} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Base_url } from "../config";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import leave from '../component/leave.json' 
import { Inlogo, Bbpsasured, xopaylogo2, susimg, fineimg } from '../component/image';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';


let Producredu = ({gobackk , charge : chargessss , fffg , smss , allsselasb , datadfg , dataedd , chargggesone }) => {
  let [ datas , setDatas ] = useState() 
  let navigate = useNavigate();

   let [data, setData] = useState();
     const [htmlString, sethtmlString] = useState("");

  let [datae, setDatae] = useState();
 const contentRef = useRef(); 
  let [indexs, setIndex] = useState(0);
  let [count, setCount] = useState();

  let [pikk, setPikk] = useState(false);

  let [selas, setSelas] = useState();
  let [sel, setSel] = useState("All");

  let [selkd, setSelkd] = useState("All");

  let [selsame, setSelsame] = useState("All");
  let [selkdone, setSelkdone] = useState("All"); 

  let [datadd, setDatadd] = useState(false);
  let [charggges, setChsrggess] = useState();

  let [ff, setFF] = useState();

  let [sms, setSms] = useState([]);
    let [allsselasdata, setallSelasdata] = useState();
     let [allsselas, setallSelas] = useState(); 
  let [pg_res, Setpg_res] = useState();
  let [prepaidfees, setPrepaidfees] = useState();

    let [charge, setCharge] = useState();

  let [notes, setNotes] = useState("");
  let [notesshow, setNotesshow] = useState(false);

  let [invoicedate, setinvoicedate ] = useState();
  let [invoiceorderno, setinvoiceorderno ] = useState();
  let [invoiceinvoicenumber, setinvoiceinvoicenumber ] = useState();
  let [invoiceaddress, setinvoiceaddress ] = useState();


  let [ones, setones] = useState(0);
  let [twos, settwos] = useState(0);
  let [threes, setthrees] = useState(0);
  let [fouers, setfouers] = useState(0);
  const [text, setText] = useState("");
   let [showrefund, setShowrefund] = useState(false);

  useEffect(()=>{
     setFF(fffg)
     setSms(smss)
     setCharge(chargessss)
     setallSelas(allsselasb)
     setData(datadfg)
     setDatae(dataedd)
     setChsrggess(chargggesone)
  },[])

 function newaddWorkingDayt3(count, twoo , hhh) {
        let currentDate = new Date(hhh); // Start with today's date
        let daysAdded = 0; // Keep track of how many valid days we've added
    
        // Helper function to check if the current date is in the 'twoo' array
        function isInTwoo(date) {
            let dateStr = date.toLocaleDateString("en-GB"); // Format date as 'DD/MM/YYYY'
            return twoo.includes(dateStr);
        }
    
        while (daysAdded < count) {
            currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
            let dayOfWeek = currentDate.getDay(); // 0 is Sunday, 6 is Saturday
    
            // Skip Sundays
            if (dayOfWeek === 0) {
                continue;
            }
    
            // Skip all Saturdays
            if (dayOfWeek === 6) {
                continue;
            }
    
            // Skip dates in the 'twoo' array
            if (isInTwoo(currentDate)) {
                continue;
            }
    
            daysAdded++; // Only increment if it's a valid day (not skipped)
        }
    
        return currentDate.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit", 
            year: "numeric",
        });
      }

    let marklist = async (tt) => {

    try {
      let token = await localStorage.getItem("token");
      let pp = { token, userid: tt.id, verify: tt.user.marklist };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/marklist",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);


          if (Jsson.status === true) {
            if (Jsson.data === 0) {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id
                    ? {
                      ...item,
                      user: {
                        ...item.user,
                        marklist: true,
                      },
                    }
                    : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                const updatedData = {
                  ...charge,
                  user: {
                    ...charge.user,
                    marklist: true,
                  },
                };

                setCharge(updatedData);

                // setFF({ ...ff, freeze: true });
              }
            } else {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id
                    ? {
                      ...item,
                      user: {
                        ...item.user,
                        marklist: false,
                      },
                    }
                    : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                const updatedData = {
                  ...charge,
                  user: {
                    ...charge.user,
                    marklist: false,
                  },
                };

                setCharge(updatedData);
                // setFF({ ...ff, freeze: false });
              }
            }
          } else {
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };

     let selectedddhahas = async () => {

    console.log(ff, 'ffffffffffffffffffffffffffffffffffffffffffff')

    let ggggg = `
    
    
     <!DOCTYPE html>
              <html lang="en">
              
              <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>Receipt</title>
                <style>
                    body {
                        font-family: Arial, sans-serif;
                    }
              
                    .invoice {
                        padding: 20px;
                    }
              
                    .invoice2 {
                        height: auto;
                        margin: 0 auto; 
                        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                        padding-left : 20px;
                        padding-right : 20px;
                        padding-top : 30px;
                    }
              
                    .header {
                        text-align: center;
                        font-size: 24px;
                        margin-bottom: 20px;
                    }
              
                    .details {}
              
                    .item {
                        display: flex;
                        justify-content: space-around;
                        margin-bottom: 10px;
                    }
              
                    .item-top {
                        display: flex;
                        justify-content: space-between;
                    }
              
                    .item span {
                        flex: 1;
                        text-align: center;
                    }
              
                    .total {
                        font-weight: bold;
                        font-size: 18px;
                    }
              
                    .divider {
                      border: none;
                      height: 1px;
                      background-color: #ababab;
                      margin: 20px 0; /* Adjust margin as needed */
                      opocity: 0.1; 
                      margin-top: -0px;
                    }
                </style>
              </head>
              
              <body>
                <div class="invoice2">
              
              
                    <div>
                        <div style=" background-color: #fff; padding : 10px ">
                            <div style="display : flex; justify-content : space-between ">
                                <div> 
                                    <img style='width : 125px' src='data:image/png;base64,${fineimg}' />
                                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px ; margin-top : 20px; ">Wenoxo Technologies Pvt.Ltd.</p>
                                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px ">GST Regsitration No: 33AADCW5769J1ZV</p>
                                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px ">No.398A, 2nd Floor, MS Rd, Kattayanvilai,</p>
                                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px ">Nagercoil, Tamilnadu 629003</p>

                                </div>
                                <div  ">
                                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px ">Tax Invoice/bill of Supply/Cash Memo</p>
                                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px; text-align : center;">(Originial for Recipient)</p>

                                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 5px ; margin-top : 20px; ">Billing To : ${ff?.user?.name}</p>
                                    <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 0px; width : 218px ">Address : ${
                                      invoiceaddress === "" || invoiceaddress === undefined ||invoiceaddress === null ? ff?.aadhar?.address : invoiceaddress}</p>

            
                                </div>
              
                            </div>
              
                        </div>

                        <hr class="divider">
            
              
              
                      <div style="display : flex; justify-content : space-between " >
                        <div > 
                          <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ;   ">Date : ${
                            invoicedate === "" || invoicedate === undefined ||invoicedate === null ? convertDateString(ff?.createdAt) : invoicedate}</p> 
                          <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ;  ">Order No : ${invoiceorderno === "" ||
                             invoiceorderno === undefined ||invoiceorderno === null ? ff?.xopay_id : invoiceorderno}</p>
                          <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; ">Invoice Number : ${
                            invoiceinvoicenumber  === "" || invoiceinvoicenumber === undefined ||invoiceinvoicenumber === null ? ff?.pg_transactionId : invoiceinvoicenumber}</p>
                        </div>
                        <div style="margin-top : 20px" > 
                          <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; 
                          ">Status : <span style="color : ${ff?.payment_status_msg === "Processing" ? "#F99417" : ff?.payment_status_msg === "Success" ? "#0C9C18" : "#FF0000"} ">
                          
                          ${ff?.payment_status_msg}</span></p> 
                        </div>
                      </div >

                      <table style="width :100% ; margin-top : 20px">
                        <thead style=" background-color : #A6A6A630;  ">
                          <tr>
                            <th style="padding : 15px; text-align : center ; font-size : 11px">Item</th>
                            <th style="padding : 15px; text-align : center; font-size : 11px" " >Amount(₹)</th>
                            <th style="padding : 15px; text-align : center; font-size : 11px" " >Convenience
            Fees</th>
                            <th style="padding : 15px; text-align : center; font-size : 11px" " >HSN/SAC</th>
                            <th style="padding : 15px; text-align : center; font-size : 11px" " >Tax Rate & Type</th>
                            <th style="padding : 15px; text-align : center ; font-size : 11px"" >Tax Amount</th>
                            <th style="padding : 15px; text-align : center ; font-size : 11px"" >Total Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">${allsselasdata}</p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">₹ ${ff?.amount}</p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">₹ ${ff?.co_fess
                  }</p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px; text-align : center ">00000</p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">18%</p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">₹ ${ff?.gst}</p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:700; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">₹ ${ff?.totalamount}</p></td> 
                          </tr> 
                          <tr>
                            <td><p style="color : #0E0E0E ; font-weight:700; font-size : 11px ; margin-bottom : 1px ; padding : 10px ; text-align : center">Grand Total</p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px "></p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px "></p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px "></p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px "></p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; padding : 10px "></p></td> 
                            <td><p style="color : #0E0E0E ; font-weight:700; font-size : 11px ; margin-bottom : 1px ; padding : 10px; text-align : center ">₹ ${ff?.totalamount}</p></td> 
                          </tr> 

                      
                        </tbody> 
              
                      </table>
              <hr class="divider">
              
                      
                      <div style="padding : 10px" >
                        <div style="display : flex; justify-content : space-between "  >
                        <div >

                        <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ;   ">
                          
                          We declare that this invoice shows the</p> 
                          <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ;   ">actual price of 
                          the services described that all particulars are true and </p> 
                          <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ;   ">correct.</p> 


                        </div >

                        <div >

                        <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px ; text-align : right  ">*This is a computer generated invoice and does not requiree</p> 
                          <p style="color : #0E0E0E ; font-weight:400; font-size : 11px ; margin-bottom : 1px; text-align : right   ">a physical signature </p>  
                        </div >
                        </div>
                          
                        </div>


                        
                    </div>


              
                </div>
                </div>
              
              </body>
              
              </html>
              
              
              `


    sethtmlString(ggggg)


    setTimeout(() => {
      hhhfhf()
    }, 1000);






  }

   let verifyy = async (tt) => {
    console.log(tt);
    try {
      let token = await localStorage.getItem("token");
      let pp = { token, verify: tt.verified, pdid: tt._id };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin/verifyaddedu",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            if (Jsson.data === 0) {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id ? { ...item, verified: true } : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                setFF({ ...ff, verified: true });


              }
            } else {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id ? { ...item, verified: false } : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                setFF({ ...ff, verified: false });


              }
            }
          } else {
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };

    let update = async () => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, id: ff._id, change: selas };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin/rentupdateedu",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);
          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            console.log(Jsson, "hh");
            // setData(Jsson.data);
            window.location.reload();
          } else {
            alert(Jsson.message);
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };


   let hhhfhf = async () => {
    const element = contentRef.current;

    const canvas = await html2canvas(element, {
      scale: 3, // 🟢 Higher scale = sharper image
      useCORS: true,
    });
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save('receipt.pdf');
  }

   let addnotes = async (tt) => {




    if (notes === "" || notes === undefined || notes === null) {

      alert("Please enter notes");
      return;

    }
    try {

      let token = await localStorage.getItem("token");
      let pp = { token, payid: tt.pg_transactionId, msg: notes };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/addnotesedu",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);


          if (Jsson.status === true) {
            setNotes(Jsson?.data?.pay_notes)
            // let [ff, setFF] = useState();
            // setFF(ff.pay_notes = Jsson?.data?.pay_notes) 
            setFF(prev => ({
              ...prev,
              pay_notes: Jsson?.data?.pay_notes
            }));
            alert('notes added')
          } else {

          }
        })
        .catch((ee) => {

        });


    } catch (err) { }
  };


  let Freeze = async (tt) => {
    console.log(tt);
    try {
      let token = await localStorage.getItem("token");
      let pp = { token, verify: tt.freeze, pdid: tt._id };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin/freezeaddedu",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            if (Jsson.data === 0) {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id ? { ...item, freeze: true } : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                setFF({ ...ff, freeze: true });


              }
            } else {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id ? { ...item, freeze: false } : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                setFF({ ...ff, freeze: false });


              }
            }
          } else {
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };


  let reverse = async (tt) => {
    console.log(tt);
    try {
      let token = await localStorage.getItem("token");
      let pp = { token, verify: tt.reverse , pdid: tt._id };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin/reverseaddedu",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            if (Jsson.data === 0) {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id ? { ...item, reverse: true } : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                setFF({ ...ff, reverse: true });


              }
            } else {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id ? { ...item, reverse: false } : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                setFF({ ...ff, reverse: false });


              }
            }

            alert('Success')
          } else {
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };


   function openGoogleMap(ff) {


    if (ff?.location === undefined || ff?.location === '' || ff?.location === null) {
      alert('Location Not Available')
    } else {

      let loc = JSON.parse(ff?.location)
      console.log(loc, 'gggggg')
      const url = `https://www.google.com/maps?q=${loc?.coords?.latitude},${loc?.coords?.longitude}`;
      window.open(url, '_blank');  // Opens Google Maps in a new tab
    }
  }

    function convertDateString(dateString) {
    const now = new Date(dateString);

    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }


  function newaddWorkingDay(count, twoo, date) {
    let currentDate = new Date(date); // Start with today's date
    let daysAdded = 0; // Keep track of how many valid days we've added

    // Helper function to check if the current date is in the 'twoo' array
    function isInTwoo(date) {
      let dateStr = date.toLocaleDateString("en-GB"); // Format date as 'DD/MM/YYYY'
      return twoo.includes(dateStr);
    }

    while (daysAdded < count) {
      currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
      let dayOfWeek = currentDate.getDay(); // 0 is Sunday, 6 is Saturday
      let dayOfMonth = currentDate.getDate(); // Get the day of the month

      // Skip Sundays
      if (dayOfWeek === 0) {
        continue;
      }

      // Skip 2nd, 4th, and 5th Saturdays
      if (dayOfWeek === 6) {
        let weekOfMonth = Math.ceil(dayOfMonth / 7); // Determine which week it is
        if (weekOfMonth === 2 || weekOfMonth === 4 || weekOfMonth === 5) {
          continue; // Skip these Saturdays
        }
      }

      // Skip dates in the 'twoo' array
      if (isInTwoo(currentDate)) {
        continue;
      }

      daysAdded++; // Only increment if it's a valid day (not skipped)
    }

    return currentDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }

   let fffff = (datesss) => { 
    console.log(
      datesss,
      "kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk"
    );
    const date = new Date(datesss);

    // Format the date and time
    const day = date.getDate();
    const month = date.getMonth() + 1; // Months are zero-based
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // Pad the minutes and seconds with leading zeros if necessary
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    const formattedSeconds = seconds < 10 ? "0" + seconds : seconds;

    // Create the formatted date string
    const formattedDate = `${day}-${month}-${year} ${hours}:${formattedMinutes}:${formattedSeconds}`;

    console.log(formattedDate, "formattedDate");

    return formattedDate;
  };

  let logout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  }; 

  const showAlert = () => {
    window.alert("Click OK to run the function."); 
    logout();
  };

  const [isFourToFivePM, setIsFourToFivePM] = useState(false);
 

  useEffect(()=>{ 

  },[])

   let reelsubmit = async () => {


    console.log(selkdone, 'selkdoneselkdoneselkdone', ff)


    try {

      let pp = { id: ff._id, type: selkdone };

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/addtypepgs",
        data: pp,
      })
        .then((dat) => {
          console.log(dat, ' this is dataaaaaaaaaaaaaaaaa')

          if (dat.data.status) {
            ff.real_payment_type = selkdone;
            ff.real_payment_con_fees = JSON.stringify(dat.data.data)
          }

          window.location.reload();

        })
        .catch((ee) => {

        })


    } catch (err) {

    }

  }
 
  let fraud = async (tt) => {

    try {
      let token = await localStorage.getItem("token");
      let pp = { token, userid: tt.id, verify: tt.user.fraud };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/fraud",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);


          if (Jsson.status === true) {
            if (Jsson.data === 0) {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id
                    ? {
                      ...item,
                      user: {
                        ...item.user,
                        fraud: true,
                      },
                    }
                    : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                const updatedData = {
                  ...charge,
                  user: {
                    ...charge.user,
                    fraud: true,
                  },
                };

                setCharge(updatedData);

                // setFF({ ...ff, freeze: true });
              }
            } else {
              setData((prevData) =>
                prevData.map((item) =>
                  item._id === tt._id
                    ? {
                      ...item,
                      user: {
                        ...item.user,
                        fraud: false,
                      },
                    }
                    : item
                )
              );

              if (ff == undefined || ff === null || ff === "") {
              } else {
                const updatedData = {
                  ...charge,
                  user: {
                    ...charge.user,
                    fraud: false,
                  },
                };

                setCharge(updatedData);
                // setFF({ ...ff, freeze: false });
              }
            }
          } else {
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };
  return (
      

     <>
              <p
                onClick={() => {
                  gobackk()
                }}
                style={{ fontWeight: "700" }}
              >
                {"<"} Go back
              </p>
              <div>
                <div className="row">
                  <div
                    className="col-8"
                    style={{
                      border: "1px solid #ddd",
                      padding: "10px",
                      backgroundColor:
                        charge?.user?.fraud === true
                          ? "orange"
                          : charge?.user?.marklist === true
                            ? "#fc97f1"
                            : "#fff",
                    }}
                  >
                    <p onClick={() => {

                    }} style={{ fontSize: 20, fontWeight: "bold" }}>
                      User Detail
                    </p>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td>{charge?.user?.name}</td>
                        </tr>
                        <tr>
                          <p>{charge?.user?.phoneno}</p>
                            <p>{charge?.user?.email}</p>
                        </tr>
                        <tr>
                           

                           <div className="d-flex gap-3">
                            <button
                              onClick={() => {
                                verifyy(ff);
                              }}
                            >
                              Verify
                            </button>
                            <button
                              onClick={() => {
                                Freeze(ff);
                              }}
                            >
                              Freeze
                            </button>

                            <button
                              onClick={() => {
                                openGoogleMap(ff);
                              }}
                            >
                              Location
                            </button>

                            <button
                              onClick={() => {
                                fraud(ff);
                              }}
                            >
                              Fraud
                            </button>

                            <button
                              onClick={() => {
                                marklist(ff);
                              }}
                            >
                              Marklist
                            </button>

                            <button
                              onClick={() => {

                                if (notesshow === true) {
                                  setNotesshow(false);
                                } else {
                                  setNotesshow(true);
                                }


                              }}
                            >
                              Add Notes
                            </button>
                            <button
                              onClick={() => {
                                reverse(ff)
                              }}
                            >
                              Reverse
                            </button>
                          </div>
                       


                          <h4 style={{ marginBottom: 0 , marginTop : 20 }}>Invoice Section</h4>
                          <div className="row   " >

                            <div className="col-4 mt-3" >
                               <input type="text" placeholder="Date" className="form-control" onChange={(e) => {  setinvoicedate(e.target.value) }} />
                            
                            </div>

                            <div className="col-4 mt-3 " >
                               <textarea type="text" placeholder="Add Notes" className="form-control" onChange={(e) => {  setallSelasdata(e.target.value) }} />
                            
                            </div>

                             <div className="col-4 mt-3" >
                               <textarea type="text" placeholder="Order No" className="form-control" onChange={(e) => {  setinvoiceorderno(e.target.value) }} />
                            
                            </div>

                             <div className="col-4 mt-3" >
                               <textarea type="text" placeholder="Invoice Number" className="form-control" onChange={(e) => {  setinvoiceinvoicenumber(e.target.value) }} />
                            
                            </div> 

                             

                             <div className="col-4 mt-3" >
                               <textarea type="text" placeholder="Address" className="form-control" onChange={(e) => {  setinvoiceaddress(e.target.value) }} />
                            
                            </div>

                             <div className="col-4 mt-3" >
                              <button
                                onClick={() => {
                                  selectedddhahas()
                                }}
                              >
                                Download Pdf
                              </button>
                            
                            </div>

                           
 
                            

                            


                          </div>



                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div
                    className="col-4"
                    style={{ border: "1px solid #ddd", padding: "10px" }}
                  >
                    <div style={{ borderRadius: "5px" }}>
                      <table style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            <p
                              style={{
                                color:
                                  ff?.payment_status_msg === "Processing" ||
                                    ff?.payment_status_msg === "Progress"
                                    ? "orange"
                                    : ff?.payment_status_msg === "Failed"
                                      ? "red"
                                      : "green",
                                fontWeight: "700",
                              }}
                            >
                              {ff?.payment_status_msg}
                            </p>
                            <p>
                              Payment date : {convertDateString(ff?.createdAt)}
                            </p>
                            <div className="d-flex gap-3">
                              {ff?.verified === true ? (
                                <p style={{ color: "blue", fontWeight: "700" }}>
                                  Verified
                                </p>
                              ) : (
                                ""
                              )}

                              {ff?.freeze === true ? (
                                <p style={{ color: "blue", fontWeight: "700" }}>
                                  Freezed
                                </p>
                              ) : (
                                ""
                              )}

                                {ff?.reverse === true ? (
                                <p style={{ color: "blue", fontWeight: "700" }}>
                                  Reversed
                                </p>
                              ) : (
                                ""
                              )} 
                            </div>

                          

                            {ff?.payment_status_msg === "Processing" ||
                              ff?.payment_status_msg === "Progress" ? (
                              <p style={{ color: "blue", fontWeight: "700" }}>
                                Settlement :{" "}
                                {charggges?.title === "T1"
                                  ? newaddWorkingDayt3(1, leave , ff?.createdAt  )
                                  : charggges?.title === "Sameday"
                                    ? "4 to 5 hours"
                                    : charggges?.title === "T2"
                                      ? newaddWorkingDayt3(2, leave, ff?.createdAt)
                                      : charggges?.title === "T4" ?  newaddWorkingDayt3(4, leave, ff?.createdAt) : 
                                      
                                      charggges?.title === "Low" ? newaddWorkingDayt3(7, leave, ff?.createdAt) :newaddWorkingDayt3(3, leave, ff?.createdAt)  }
                              </p>
                            ) : (
                              ""
                            )}
                          </tr>
                          <tr>
                            <td
                              style={{
                                paddingRight: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              <select
                                onChange={(e) => {
                                  setSelas(e.target.value);

                                  if (e.target.value === 'Refund') {
                                    setShowrefund(true)
                                  } else {
                                    setShowrefund(false)
                                  }



                                  console.log(e.target.value, 'ggggggggggggggggggggggggggggggggggggggg')



                                }}
                                name="payment_status"
                                id="payment_status"
                                style={{
                                  padding: "5px",
                                  borderRadius: "4px",
                                  border: "1px solid #ccc",
                                }}
                              >
                                <option
                                  value="Failed"
                                  selected={ff?.payment_status_msg === "Failed"}
                                >
                                  Failed
                                </option>
                                <option
                                  value="Success"
                                  selected={
                                    ff?.payment_status_msg === "Success"
                                  }
                                >
                                  Success
                                </option>
                                <option
                                  value="Processing"
                                  selected={
                                    ff?.payment_status_msg === "Processing"
                                  }
                                >
                                  Processing 
                                </option>
                                <option
                                  value="Refund"
                                  selected={ff?.payment_status_msg === "Refund"}
                                >
                                  Refund
                                </option>
                                <option
                                  value="Chargeback"
                                  selected={ff?.chargeback === true}
                                >
                                  Charge Back
                                </option>

                              </select>
                            </td>

                            <td colSpan="2" style={{ paddingTop: "20px" }}>
                              <button
                                onClick={() => {
                                  update();
                                }}
                                style={{
                                  padding: "10px 20px",
                                  border: "none",
                                  borderRadius: "4px",
                                  backgroundColor: "#007bff",
                                  color: "white",
                                  cursor: "pointer",
                                }}
                              >
                                Submit
                              </button>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <tr>
                                {/* <div className="row" >
                                  <div className="col-6" >
                                    <p>User Remark</p>
                                    <textarea
                                      onChange={(e) => {

                                      }}
                                      type="text"
                                      style={{ width: "100%" }}
                                      placeholder="Enter Remark"
                                    />
                                  </div>
                                  <div className="col-6" >
                                    <p>Admion Remark</p>
                                    <textarea
                                      onChange={(e) => {

                                      }}
                                      type="text"
                                      style={{ width: "100%" }}
                                      placeholder="Enter Remark"
                                    />
                                  </div>
                                </div> */}
                              </tr>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div
                    className="col-6"
                    style={{ border: "1px solid #ddd", padding: "10px" }}
                  >
                    <p
                      style={{
                        fontSize: 20,
                        fontWeight: "bold",
                        marginBottom: "10px",
                      }}
                    >
                      Aadhar Detail
                    </p>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px" }}
                          >
                            Aadhar Name:
                          </td>
                          <td>{charge?.aadhar?.name}</td>
                        </tr>
                        <tr>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px" }}
                          >
                            Gender:
                          </td>
                          <td>{charge?.aadhar?.gender}</td>
                        </tr>
                        <tr>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px" }}
                          >
                            Date of Birth:
                          </td>
                          <td>{charge?.aadhar?.year_of_birth}</td>
                        </tr>
                        <tr>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px" }}
                          >
                            Address:
                          </td>
                          <td>{charge?.aadhar?.address}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div
                    className="col-6"
                    style={{ border: "1px solid #ddd", padding: "10px" }}
                  >
                    <p
                      style={{
                        fontSize: 20,
                        fontWeight: "bold",
                        marginBottom: "10px",
                      }}
                    >
                      Pan Detail
                    </p>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px" }}
                          >
                            Pan Name:
                          </td>
                          <td>{charge?.pan?.name_pan_card}</td>
                        </tr>
                        <tr>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px" }}
                          >
                            Pan Registered Name:
                          </td>
                          <td>{charge?.pan?.registered_name}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <p style={{ fontWeight: '700', color: 'red' }} className="mt-3">
                  {ff?.pay_notes}
                </p>

                {notesshow === true ? (
                  <div className="d-flex mt-3">
                    <textarea
                      onChange={(e) => { setNotes(e.target.value) }}
                      style={{ border: "1px solid #ddd", width: "50%" }}
                    ></textarea>
                    <div
                      style={{
                        alignItems: "center",
                        marginLeft: 10,
                        marginTop: 20,
                      }}
                    >
                      <button
                        style={{
                          padding: "10px 20px",
                          border: "none",
                          borderRadius: "4px",
                          backgroundColor: "#007bff",
                          color: "white",
                          cursor: "pointer",
                        }}

                        onClick={() => {
                          addnotes(ff)
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="row mt-5">
                  <div
                    className="col-12"
                    style={{ border: "1px solid #ddd", padding: "10px" }}
                  >
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px" }}
                          >
                            Xopay ID :
                          </td>
                          <td>{ff?.xopay_id}</td>
                        </tr>
                        <tr>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px" }}
                          >
                            PG Transaction ID :
                          </td>
                          <td>{ff?.pg_transactionId}</td>
                        </tr>
                        <tr>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px" }}
                          >
                            Notes : {ff?.pay_notes}
                          </td>
                        </tr>

                        <tr>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px", color: 'red' }}  >
                            User Select Payment type : {ff?.typevalue ? JSON.parse(ff?.typevalue)?.item?.name : null }
                          </td>
                        </tr>

                        <tr>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px", color: 'red' }}  >
                            charge : {ff?.typevalue ? JSON.parse(ff?.typevalue)?.item?.charge : null}
                          </td>
                        </tr>


                        {/* <tr>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "14px", color: 'green' }}  >
                            Billdesk  
                          </td>
                        </tr> */}


                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px", color: "green" }}
                          >
                            CARD LAST 4 Digit :  {(() => {
                                    if (!ff?.pg_res) return "";

                                    try {
                                      const parsed = JSON.parse(ff.pg_res);
                                      return parsed?.paymentDetails[0]?.instrument?.maskedCardNumber || "";
                                    } catch (err) {
                                      console.error("Invalid JSON:", err);
                                      return "";
                                    }
                                  })()}   
                          </td>

                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px", color: "green" }}
                          >
                            Issuer Bank :  {(() => {
                                if (!ff?.pg_res) return "";

                                try {
                                  const parsed = JSON.parse(ff.pg_res);
                                  return parsed?.paymentDetails[0]?.instrument?.bankId || "";
                                } catch (err) {
                                  console.error("Invalid JSON:", err);
                                  return "";
                                }
                              })()}   
                                                      </td>

                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px", color: "green" }}
                          >
                           Network :  {(() => {
                                  if (!ff?.pg_res) return "";

                                  try {
                                    const parsed = JSON.parse(ff.pg_res);
                                    return parsed?.paymentDetails[0]?.instrument?.cardNetwork || "";
                                  } catch (err) {
                                    console.error("Invalid JSON:", err);
                                    return "";
                                  }
                                })()}    
                          </td>

                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px", color: "green" }}
                          >
                           Card Type :   {(() => {
                              if (!ff?.pg_res) return "";

                              try {
                                const parsed = JSON.parse(ff.pg_res);
                                return parsed?.paymentDetails[0]?.instrument?.type || "";
                              } catch (err) {
                                console.error("Invalid JSON:", err);
                                return "";
                              }
                            })()}       
                          </td>


                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="row">
                  <div className="col-3" style={{ border: "1px solid #ddd" }}>
                    <p style={{ fontSize: 20, fontWeight: "bold" }}>
                      Beneficiary Detail
                    </p>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ fontWeight: "bold" }}>Name:</td>
                          <td>{datae?.name}</td>
                        </tr>
                        <tr>
                          <td style={{ fontWeight: "bold" }}>Phone:</td>
                          <td>{datae?.phone}</td>
                        </tr>
                        <tr>
                          <td style={{ fontWeight: "bold" }}>Email:</td>
                          <td>{datae?.email}</td>
                        </tr>
                        <tr>
                          <td style={{ fontWeight: "bold" }}>Account No:</td>
                          <td>{datae?.bankaccountno}</td>
                        </tr>
                        <tr>
                          <td style={{ fontWeight: "bold" }}>IFSC code:</td>
                          <td>{datae?.ifsc}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    className="col-3"
                    style={{ border: "1px solid #ddd", padding: "10px" }}
                  >
                    <p style={{ fontSize: 20, fontWeight: "bold" }}>
                      Payment Detail
                    </p>

                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              fontWeight: "bold",
                              paddingRight: "10px",
                              color: "red",
                            }}
                          >
                            Charge:
                          </td>
                          <td style={{ color: "red" }}>{charggges?.title}</td>
                        </tr>
                        <tr>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px" }}
                          >
                            Fees:
                          </td>
                          <td>{charggges?.fee}</td>
                        </tr>
                        <tr>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px" }}
                          >
                            Amount:
                          </td>
                          <td>₹ {ff?.amount}</td>
                        </tr>
                        <tr>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px" }}
                          >
                            Convenience Fees:
                          </td>
                          <td>₹ {ff?.co_fess}</td>
                        </tr>
                        <tr>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px" }}
                          >
                            GST:
                          </td>
                          <td>₹ {ff?.gst}</td>
                        </tr>
                        <tr>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px" }}
                          >
                            reward:
                          </td>
                          <td>₹ - {ff?.reward || 0}</td>
                        </tr>

                        <tr style={{ marginBottom: 20 }}>
                          <td
                            style={{ fontWeight: "bold", paddingRight: "10px" }}
                          >
                            Total:
                          </td>
                          <td>₹ {ff?.totalamount}</td>
                        </tr>

                        {pg_res?.data?.payment?.payment_group ===
                          "prepaid_card" ||
                          pg_res?.cardCategory === "prepaid" ? (
                          <>
                            <tr style={{ paddingTop: 20 }}>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  paddingRight: "10px",
                                  color: "red",
                                }}
                              >
                                prepaid_card charge :
                              </td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  paddingRight: "10px",
                                  color: "red",
                                }}
                              >
                                ₹ {prepaidfees}
                              </td>
                            </tr>

                            <tr style={{ paddingTop: 20 }}>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  paddingRight: "10px",
                                  color: "red",
                                }}
                              >
                                prepaid_card GST :
                              </td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  paddingRight: "10px",
                                  color: "red",
                                }}
                              >
                                ₹ {text}
                              </td>
                            </tr>

                            <tr>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  paddingRight: "10px",
                                  color: "red",
                                }}
                              >
                                Final Settlement Amount :
                              </td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  paddingRight: "10px",
                                  color: "red",
                                }}
                              >
                                ₹ {Number(ff.amount) - prepaidfees - text}
                              </td>
                            </tr>
                          </>
                        ) : (
                          ""
                        )}
                      </tbody>
                    </table>



                    {

                      ff?.real_payment_type === "" || ff?.real_payment_type === undefined || ff?.real_payment_type === null ?
                        ""
                        :

                        <>
                          <p style={{ fontSize: 20, fontWeight: "bold" }} className="mt-5">
                            After change Payment Detail
                          </p>

                          <table style={{ width: "100%" }} >
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    paddingRight: "10px",
                                    color: "red",
                                  }}
                                >
                                  Charge:
                                </td>
                                <td style={{ color: "red" }}>{charggges?.title}</td>
                              </tr>
                              <tr>
                                <td
                                  style={{ fontWeight: "bold", paddingRight: "10px" }}
                                >
                                  Fees:
                                </td>
                                <td>{charggges?.fee}</td>
                              </tr>
                              <tr>
                                <td
                                  style={{ fontWeight: "bold", paddingRight: "10px" }}
                                >
                                  Amount:
                                </td>
                                <td>₹ {ff?.amount}</td>
                              </tr>


                              <tr>
                                <td
                                  style={{ fontWeight: "bold", paddingRight: "10px", color: 'red' }}
                                >
                                  New Convenience Fees present :
                                </td>
                                <td style={{ color: 'red' }}>
                                  {(() => {
                                    try {
                                      const parsed = JSON.parse(ff?.real_payment_con_fees || '[]');
                                      return `${parsed?.[0]?.charge ?? '-'} %`;
                                    } catch {
                                      return '- %';
                                    }
                                  })()}
                                </td>
                              </tr>

                              <tr>
                                <td
                                  style={{ fontWeight: "bold", paddingRight: "10px" }}
                                >
                                  Convenience Fees:
                                </td>
                                <td>
                                  ₹ {
                                    (() => {
                                      try {
                                        const chargeFee = Number(JSON.parse(ff?.charge || '{}')?.fee || 0);
                                        const realPaymentFee = Number(JSON.parse(ff?.real_payment_con_fees || '[]')?.[0]?.charge || 0);
                                        const amount = Number(ff?.amount || 0);

                                        const total = ((chargeFee + realPaymentFee) / 100) * amount;
                                        return total.toFixed(2);
                                      } catch {
                                        return '0.00';
                                      }
                                    })()
                                  }
                                </td>
                              </tr>


                              <tr>
                                <td
                                  style={{ fontWeight: "bold", paddingRight: "10px" }}
                                >
                                  GST:
                                </td>
                                <td>
                                  ₹ {
                                    (() => {
                                      try {
                                        const chargeFee = Number(JSON.parse(ff?.charge || '{}')?.fee || 0);
                                        const realPaymentFee = Number(JSON.parse(ff?.real_payment_con_fees || '[]')?.[0]?.charge || 0);
                                        const amount = Number(ff?.amount || 0);

                                        const baseCharge = ((chargeFee + realPaymentFee) / 100) * amount;
                                        const gst = (baseCharge * 18) / 100;

                                        return gst.toFixed(2);
                                      } catch {
                                        return '0.00';
                                      }
                                    })()
                                  }
                                </td>
                              </tr>


                              <tr>
                                <td
                                  style={{ fontWeight: "bold", paddingRight: "10px" }}
                                >
                                  reward:
                                </td>
                                <td>₹ - {ff?.reward || 0}</td>
                              </tr>

                              <tr style={{ marginBottom: 20 }}>
                                <td
                                  style={{ fontWeight: "bold", paddingRight: "10px" }}
                                >
                                  Total:
                                </td>
                                <td>
                                  ₹ {
                                    (() => {
                                      try {
                                        const chargeFee = Number(JSON.parse(ff?.charge || '{}')?.fee || 0);
                                        const realPaymentFee = Number(JSON.parse(ff?.real_payment_con_fees || '[]')?.[0]?.charge || 0);
                                        const amount = Number(ff?.amount || 0);

                                        const baseCharge = ((chargeFee + realPaymentFee) / 100) * amount;
                                        const gst = (baseCharge * 18) / 100;
                                        const total = amount + baseCharge + gst;

                                        return total.toFixed(2);
                                      } catch {
                                        return '0.00';
                                      }
                                    })()
                                  }
                                </td>
                              </tr>


                              <tr style={{ marginBottom: 20 }}>
                                <td
                                  style={{ fontWeight: "bold", paddingRight: "10px" }}
                                >
                                  Settlement Amount :
                                </td>
                                <td>
                                  ₹ {
                                    (() => {
                                      try {
                                        const chargeFee = Number(JSON.parse(ff?.charge || '{}')?.fee || 0);
                                        const realPaymentFee = Number(JSON.parse(ff?.real_payment_con_fees || '[]')?.[0]?.charge || 0);
                                        const amount = Number(ff?.amount || 0);

                                        const baseCharge = ((chargeFee + realPaymentFee) / 100) * amount;
                                        const gst = (baseCharge * 18) / 100;
                                        const total = amount + baseCharge + gst;
                                        let totalamount = Number(ff?.totalamount || 0)
                                        let givenamount = total - totalamount

                                        let finalconamount = 0

                                        if (givenamount < 0) {
                                          finalconamount = amount + Math.abs(givenamount)
                                        } else {
                                          finalconamount = amount - Math.abs(givenamount)
                                        }


                                        return finalconamount.toFixed(2);
                                      } catch {
                                        return '0.00';
                                      }
                                    })()
                                  }
                                </td>
                              </tr>


                              {pg_res?.data?.payment?.payment_group ===
                                "prepaid_card" ||
                                pg_res?.cardCategory === "prepaid" ? (
                                <>
                                  <tr style={{ paddingTop: 20 }}>
                                    <td
                                      style={{
                                        fontWeight: "bold",
                                        paddingRight: "10px",
                                        color: "red",
                                      }}
                                    >
                                      prepaid_card charge :
                                    </td>
                                    <td
                                      style={{
                                        fontWeight: "bold",
                                        paddingRight: "10px",
                                        color: "red",
                                      }}
                                    >
                                      ₹ {prepaidfees}
                                    </td>
                                  </tr>

                                  <tr style={{ paddingTop: 20 }}>
                                    <td
                                      style={{
                                        fontWeight: "bold",
                                        paddingRight: "10px",
                                        color: "red",
                                      }}
                                    >
                                      prepaid_card GST :
                                    </td>
                                    <td
                                      style={{
                                        fontWeight: "bold",
                                        paddingRight: "10px",
                                        color: "red",
                                      }}
                                    >
                                      ₹ {text}
                                    </td>
                                  </tr>

                                  <tr>
                                    <td
                                      style={{
                                        fontWeight: "bold",
                                        paddingRight: "10px",
                                        color: "red",
                                      }}
                                    >
                                      Final Settlement Amount :
                                    </td>
                                    <td
                                      style={{
                                        fontWeight: "bold",
                                        paddingRight: "10px",
                                        color: "red",
                                      }}
                                    >
                                      ₹ {Number(ff.amount) - prepaidfees - text}
                                    </td>
                                  </tr>
                                </>
                              ) : (
                                ""
                              )}
                            </tbody>
                          </table>
                        </>

                    }



                  </div>
                  <div className="col-6" style={{ border: "1px solid #ddd" }}>
                    {sms?.length !== 0 ? (
                      <table className="table table-bordered">
                        <thead className="thead-dark">
                          <tr>
                            <th scope="col">Send By</th>
                            <th scope="col">Time</th>
                            <th scope="col">Message</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sms?.map((tt, index) => (
                            <tr key={index} style={{ cursor: "pointer" }}>
                              <td>{tt?.address}</td>
                              <td>{fffff(tt?.date_sent)}</td>
                              <td>{tt?.body}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <p>No SMS data available</p>
                    )}
                  </div>
                </div>
              </div>



              <div className="row mt-4" >

                <div className="col-6" >
                  <p
                    style={{
                      fontSize: 20,
                      fontWeight: "bold",
                      marginBottom: "10px",
                      cursor: "pointer",
                    }}
                    onClick={() => {

                    }}
                  >
                    Pg Responce <span style={{ color: "blue" }}>{ff?.pg}</span>
                  </p>

                  {(() => {
                      try {
                        const pgRes = chargessss?.pg_res ? JSON.parse(chargessss.pg_res) : null;
                        return pgRes?.card_no ? (
                          <p style={{ fontSize: 20, fontWeight: "bold", color: "red" }}>
                            Card No : {pgRes.card_no}
                          </p>
                        ) : null;
                      } catch (error) {
                        console.warn("Invalid JSON in pg_res:", chargessss?.pg_res);
                        return null;
                      }
                    })()}

                  
                </div>
                <div className="col-3" >
                  <select
                    onChange={(e) => {
                      setSelkdone(e.target.value);
                    }}
                  >
                    <option
                      value="visa"
                      selected={selkdone === "visa" ? true : false}
                    >
                      visa
                    </option>
                    <option
                      value="master"
                      selected={selkdone === "master" ? true : false}
                    >
                      master
                    </option>
                    <option
                      value="RuPay"
                      selected={selkdone === "RuPay" ? true : false}
                    >
                      RuPay
                    </option>

                    <option
                      value="AMEX"
                      selected={selkdone === "AMEX" ? true : false}
                    >
                      AMEX
                    </option>

                    <option
                      value="Dynex"
                      selected={selkdone === "Dynex" ? true : false}
                    >
                      Dynex
                    </option>

                    <option
                      value="Wallet"
                      selected={selkdone === "Wallet" ? true : false}
                    >
                      Wallet
                    </option>

                  </select>
                </div>
                <div className="col-3" >
                  <button
                    onClick={() => {
                      reelsubmit()
                    }}
                  >
                    Submit
                  </button>
                </div>

              </div>

              <table style={{ width: "100%", marginBottom: 50 }}>
                <tbody className="row">
                  <tr className="col">
                    <td>
                      {pg_res?.data?.customer_details?.customer_name ||
                        pg_res?.firstname}
                    </td>
                  </tr>
                  <tr className="col">
                    <td>
                      {pg_res?.data?.customer_details?.customer_email ||
                        pg_res?.email}
                    </td>
                  </tr>
                  <tr className="col">
                    <td>
                      {pg_res?.data?.customer_details?.customer_phone ||
                        pg_res?.phone}
                    </td>
                  </tr>
                  <tr className="col">
                    <td>
                      {pg_res?.data?.payment?.payment_group || pg_res?.mode}
                    </td>
                  </tr>
                  <tr className="col">
                    <td>
                      {pg_res?.data?.payment?.payment_method?.card
                        ?.card_number || pg_res?.cardnum}
                    </td>
                  </tr>
                  <tr className="col">
                    <td>
                      {pg_res?.data?.payment?.payment_method?.card
                        ?.card_network || pg_res?.cardCategory}
                    </td>
                  </tr>
                  <tr className="col">
                    <td>
                      {pg_res?.data?.payment?.cf_payment_id ||
                        pg_res?.bank_ref_num}
                    </td>
                  </tr>
                  <tr className="col">
                    <td>
                      {pg_res?.data?.payment?.payment_amount ||
                        pg_res?.net_amount_debit}
                    </td>
                  </tr>
                </tbody>
              </table>

              {charge?.pay?.length === 0 || charge?.pay === undefined ? (
                ""
              ) : (
                <>
                  <div className="d-flex">
                    <div className=" ">
                      <p
                        style={{
                          fontSize: 20,
                          fontWeight: "bold",
                          marginBottom: "10px",
                          cursor: "pointer",
                        }}
                      >
                        Previous Payment
                      </p>
                    </div>
                    <div className="" style={{ marginLeft: 20 }}>
                      <select
                        onChange={(e) => {
                          setSelkd(e.target.value);
                        }}
                        name="cars"
                        id="cars"
                      >
                        <option
                          value="All"
                          selected={selkd === "All" ? true : false}
                        >
                          All
                        </option>
                        <option
                          value="Failed"
                          selected={selkd === "Failed" ? true : false}
                        >
                          Failed
                        </option>
                        <option
                          value="Success"
                          selected={selkd === "Success" ? true : false}
                        >
                          Success
                        </option>
                        <option
                          value="Processing"
                          selected={selkd === "Processing" ? true : false}
                        >
                          Processing
                        </option>

                        <option
                          value="Refund"
                          selected={selkd === "Refund" ? true : false}
                        >
                          Refund
                        </option>

                        <option
                          value="verified"
                          selected={selkd === "verified" ? true : false}
                        >
                          Verified
                        </option>
                      </select>
                    </div>
                  </div>

                  <table
                    className="table table-bordered"
                    style={{ width: "90%", marginBottom: 50 }}
                  >
                    <tbody>
                      {charge?.pay?.slice().reverse().map((dfr, key) => {
                        if (selkd === "All") {
                        } else if (selkd === "Processing") {
                          if (dfr?.payment_status_msg != "Processing") {
                            return;
                          }
                        } else if (selkd === "Failed") {
                          if (dfr?.payment_status_msg != "Failed") {
                            return;
                          }
                        } else if (selkd === "Success") {
                          if (dfr?.payment_status_msg != "Success") {
                            return;
                          }
                        } else if (selkd === "Refund") {
                          if (dfr?.payment_status_msg != "Refund") {
                            return;
                          }
                        } else if (selkd === "verified") {
                          if (dfr?.verified != true) {
                            return;
                          }
                        }

                        let parsedata = "";
                        if (
                          dfr?.pg_res === "" ||
                          dfr?.pg_res === undefined ||
                          dfr?.pg_res === null
                        ) {
                          parsedata = {
                            data: {
                              order: {
                                order_id: "",
                                order_amount: "",
                                order_currency: "",
                                order_tags: null,
                              },
                              payment: {
                                cf_payment_id: "",
                                payment_status: "",
                                payment_amount: "",
                                payment_currency: "",
                                payment_message: "",
                                payment_time: "",
                                bank_reference: "",
                                auth_id: null,
                                payment_method: {
                                  card: {
                                    channel: null,
                                    card_number: "",
                                    card_network: "",
                                    card_type: "",
                                    card_sub_type: "",
                                    card_country: "",
                                    card_bank_name: "",
                                  },
                                },
                                payment_group: "",
                              },
                              customer_details: {
                                customer_name: "",
                                customer_id: "",
                                customer_email: "",
                                customer_phone: "",
                              },
                              error_details: {
                                error_code: "",
                                error_description: "",
                                error_reason: "",
                                error_source: "",
                                error_code_raw: null,
                                error_description_raw: null,
                              },
                              payment_gateway_details: {
                                gateway_name: "",
                                gateway_order_id: null,
                                gateway_payment_id: "",
                                gateway_status_code: null,
                                gateway_order_reference_id: "",
                                gateway_settlement: null,
                              },
                              payment_offers: null,
                            },
                            event_time: "",
                            type: "",
                          };
                        } else {
                          parsedata = JSON.parse(dfr?.pg_res);
                        }



                        console.log(dfr , 'parsedataparsedataparsedataparsedataparsedataparsedataparsedataparsedataparsedata')

                        let gg = {};

                        if (dfr?.charge) {
                          gg = JSON.parse(dfr?.charge);
                        }

                        return (
                          <tr key={key} style={{ cursor: "pointer" }}>
                            <td>
                              <p style={{ fontWeight: "700" }}>
                                card User Detail
                              </p>

                              <p>
                              {charge?.user?.name}
                              </p>
                              <p>
                              {charge?.user?.phoneno}
                              </p>
                              <p>
                              {charge?.user?.email}
                              </p> 
                            </td>
                            <td>
                              <p style={{ fontWeight: "700" }}>Ids</p>

                              <p>{dfr?.xopay_id}</p>
                              <p>
                                {dfr?.pg_transactionId}
                              </p>
                            </td>

                            <td>
                              <p>
                                { convertDateString(dfr?.createdAt)}
                              </p>
                              <p>
                                {dfr?.pg}
                              </p>
                            </td>

                            <td>
                              <p style={{ color: "red" }}>
                                Type : {gg?.title}{" "}
                              </p>
                              <p>Con fees present : {gg?.fee} %</p>
                              <p>Con fees : {dfr?.co_fess}</p>
                              <p>gst : {dfr?.gst} %</p>
                              <p>
                                Total :{" "}
                                {dfr?.totalamount}
                              </p>
                            </td>
                            <td>
                              <p
                                style={{
                                  color:
                                    dfr?.payment_status_msg === "Processing" ||
                                      dfr?.payment_status_msg === "Progress"
                                      ? "orange"
                                      : dfr?.payment_status_msg === "Failed"
                                        ? "red"
                                        : "green",
                                  fontWeight: "700",
                                }}
                              >
                                {dfr?.payment_status_msg}
                              </p>

                              <div className="d-flex gap-3">
                                {dfr?.verified === true ? (
                                  <p
                                    style={{ color: "blue", fontWeight: "700" }}
                                  >
                                    Verified
                                  </p>
                                ) : (
                                  ""
                                )}
                                {dfr?.freeze === true ? (
                                  <p
                                    style={{ color: "blue", fontWeight: "700" }}
                                  >
                                    Freezed
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </>
              )}


              <div
                ref={contentRef}
                style={{ width: '215mm', backgroundColor: 'white', zIndex: 10000 }}
                dangerouslySetInnerHTML={{ __html: htmlString }}
              />


            </>

            
  );
};

export default Producredu;
